import React from 'react';
import { Award, Target, Zap, Trophy } from 'lucide-react';

const features = [
  {
    icon: Award,
    title: 'Fantasy-Specific Names',
    description: 'Names tailored for fantasy football leagues and team managers.'
  },
  {
    icon: Target,
    title: 'Multiple Styles',
    description: 'Choose from funny, clever, intimidating, or player-based names.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get unique fantasy team names in seconds.'
  },
  {
    icon: Trophy,
    title: 'League-Winning Names',
    description: 'Stand out in your fantasy league with a memorable team name.'
  }
];

export default function FantasyFootballFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Fantasy Football Name Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-green-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-green-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}